import styled from 'styled-components';

export const StyledWorkingHoursInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: ${({ isLastOfSection }) => (isLastOfSection ? '1rem 3rem 0 3rem' : '1rem 3rem')};
  width: calc(100% - 6rem);
  border-bottom:  ${({ isLastOfSection }) => (isLastOfSection ? 'none' : '1px solid #757575')};
  
  button.MuiIconButton-root {
    margin-top: -14px;
    margin-right: 20px;
  }

`;

export const StyledWorkingIHoursDays = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto 0 0;
  width: 70%;

  p.title {
    font-weight: bold;
  }

  p {
    font-size: 1.4rem;
  }
`;

export const StyledTimeRange = styled(StyledWorkingIHoursDays)`
  display: flex;
  flex-direction: column;

  li {
    flex-direction: row;
    padding: 0;
    background: transparent;
    margin-bottom: 0;
  }

  p {
    display: flex;
    margin: 0 auto 0 0;
    width: 70%;
    font-size: 1.4rem;
    margin-bottom: 0.5rem ;
  }
`;

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
